<template>
  <div id="app">
    <ExcelSheet
      file-name="TransferBookingExcel"
      :import-data="importData"
    >
      <template v-slot:top>
        <div style="width:300px ;float:left; ">
          <universal-input
            v-model="centerFilter"
            label="Center"
            :config="centerFilterConfig"
          >
          </universal-input>
        </div>

        <div style="width:300px ;float:left; ">
          <universal-input
            v-model="salesFilter"
            label="Sales"
            :config="salesFilterConfig"
          >
          </universal-input>
        </div>

        <div
          style="width:300px ;float: left; padding-left:12px"
        >
          <universal-input
            v-model="courseFromDate"
            :config="courseFromDateConfig"
            @input="handleCourseFromDateInput"
          ></universal-input>
        </div>
      </template>
    </ExcelSheet>
  </div>
</template>

<script setup>

import { ref, onMounted, computed, toRefs, watch, onBeforeMount } from 'vue'
import { autoResetRef } from '@vueuse/core'
import { mdiCarTractionControl } from '@mdi/js'
import ExcelSheet from '@/components/Excel/excelSheet.vue'

import { showExcel } from '@/api/salesOrder'

import { FetchSalesListForReport as fetchSales } from '@/api/orderSalesman'

import { ownCenterList } from '@/api/center'

import moment from '@/utils/moment'

import UniversalInput from '@/components/CRUD/UniversalInput'

// import { UnboundTypeError } from '@techstark/opencv-js'
let AllCenter = ''
let AllCenterArray = [{id : 0 , label : 'ALL'}]
const headerJSON_1 = ref([])
const headerJSON_2 = ref([])
const coachCenterList = ref([])
const TempData_1 = ref([])
const TempData_2 = ref([])
const importData = ref({})
const merge_1 = ref([])
const merge_2 = ref([])

const calcChain_1 = ref([])
const calcChain_2 = ref([])

// const tableBorder =
const centerFilter = ref(0)
const centerFilterConfig = ref({
  name: 'centerFilter',
  label: 'Center',
  type: {
    name: 'autocomplete',
    items: coachCenterList.value,
  },
})

const salesFilter = ref(0)
const salesList = ref([{
  id: 0,
  label: 'ALL',
  userRecordID: 0,
}])

const salesFilterConfig = ref({
  name: 'salesFilter',
  label: 'Sales',
  type: {
    name: 'autocomplete',
    items: salesList.value,
  },
})

const courseFromDate = ref('')
const startingWeek = ref(0)
const weeklyData = ref({})

const borderTable_1 = ref([])
const borderTable_2 = ref([])
const tempSalesID = ref(0)

const courseFromDateConfig = ref({
  propName: 'courseFromDate',
  label: 'From Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})

watch(centerFilter, newValue => {
  callSalesListAPI({ centerID: newValue }).then(templist => {
    if (newValue) {
      if (templist.findIndex(item => item.id == salesFilter.value) === -1) {
        console.log('AllCenterArray', AllCenterArray)
        salesFilter.value = 0
        headerJSON_1.value = [
          { Info: 'Monthly Sales Report - Personal by Daily', fs: 18 },
          { Info: 'Coach Name : ALL' },
          { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === newValue)].label}` },
          { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

          // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
          { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
          { Info: '' }, // Empty row
          { Info: '' }, // Empty row
          { Info: '' }, //  Empty row
          { Info: '' }, // Empty row
          { Info: '', bg: '#2F75B5' }, // for header row 5
          // #D9D9D9  other gray
        ]

        headerJSON_2.value = [
          { Info: 'Monthly Sales Report - Personal by Weekly', fs: 18 },
          { Info: 'Coach Name : ALL' },
          { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === newValue)].label}` },
          { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

          // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
          { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
          { Info: '' }, // Empty row
          { Info: '' }, // Empty row
          { Info: '' }, // for header row 5
          { Info: '', bg: '#2F75B5' }, // for header row 5
          // #D9D9D9  other gray
        ]

        callAPI({ CenterID: newValue,
          TheMonth: courseFromDate.value,
          SalesID: 0 })
      } else {
        console.log('notsalesList-1a')

        headerJSON_1.value = [
          { Info: 'Monthly Sales Report - Personal by Daily', fs: 18 },
          { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === salesFilter.value)].label}` },
          { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === newValue)].label}` },
          { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

          // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
          { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
          { Info: '' }, // Empty row
          { Info: '' }, // Empty row
          { Info: '' }, //  Empty row
          { Info: '' }, // Empty row
          { Info: '', bg: '#2F75B5' }, // for header row 5
          // #D9D9D9  other gray
        ]

        headerJSON_2.value = [
          { Info: 'Monthly Sales Report - Personal by Weekly', fs: 18 },
          { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === salesFilter.value)].label}` },
          { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === newValue)].label}` },
          { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

          // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
          { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
          { Info: '' }, // Empty row
          { Info: '' }, // Empty row
          { Info: '' }, // for header row 5
          { Info: '', bg: '#2F75B5' }, // for header row 5
          // #D9D9D9  other gray
        ]

        callAPI({ CenterID: newValue,
          TheMonth: courseFromDate.value,
          SalesID: salesList.value[salesList.value.findIndex(item => item.id === salesFilter.value)].id })
      }
    } else {
    // old Value

      // salesFilter.value = 0
      // console.log('salesFilter.valueaa',newValue)
      console.log('AllCenterArray[0].label',AllCenterArray[0].label)
      headerJSON_1.value = [
        { Info: 'Monthly Sales Report - Personal by Daily', fs: 18 },
        { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === salesFilter.value)].label}` },
        { Info:  `Center : ${AllCenterArray[0].label}` },
        { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

        // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
        { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
        { Info: '' }, // Empty row
        { Info: '' }, // Empty row
        { Info: '' }, //  Empty row
        { Info: '' }, // Empty row
        { Info: '', bg: '#2F75B5' }, // for header row 5
        // #D9D9D9  other gray
      ]

      headerJSON_2.value = [
        { Info: 'Monthly Sales Report - Personal by Weekly', fs: 18 },
        { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === salesFilter.value)].label}` },
        { Info: `Center : ${AllCenterArray[0].label}` },
        { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

        // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
        { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
        { Info: '' }, // Empty row
        { Info: '' }, // Empty row
        { Info: '' }, // for header row 5
        { Info: '', bg: '#2F75B5' }, // for header row 5
        // #D9D9D9  other gray
      ]

      callAPI({ CenterID: 0,
        TheMonth: courseFromDate.value,
        SalesID: salesList.value[salesList.value.findIndex(item => item.id === salesFilter.value)].id })
    }
  })
})

watch(salesFilter, newValue => {
  if (newValue) {
    console.log('AllCenterArray', AllCenterArray)
    callAPI({ CenterID: centerFilter.value,
      TheMonth: courseFromDate.value,

      SalesID: salesList.value[salesList.value.findIndex(item => item.id === newValue)].id,
    })

    headerJSON_1.value = [
      { Info: 'Monthly Sales Report - Personal by Daily', fs: 18 },
      { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === newValue)].label}` },
      { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === centerFilter.value)].label}` },
      { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

      // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
      { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
      { Info: '' }, // Empty row
      { Info: '' }, // Empty row
      { Info: '' }, //  Empty row
      { Info: '' }, // Empty row
      { Info: '', bg: '#2F75B5' }, // for header row 5
    // #D9D9D9  other gray
    ]

    headerJSON_2.value = [
      { Info: 'Monthly Sales Report - Personal by Weekly', fs: 18 },
      { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === newValue)].label}` },
      { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === centerFilter.value)].label}` },
      { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

      // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
      { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
      { Info: '' }, // Empty row
      { Info: '' }, // Empty row
      { Info: '' }, // for header row 5
      { Info: '', bg: '#2F75B5' }, // for header row 5
    // #D9D9D9  other gray
    ]
  } else {
    callAPI({ CenterID: centerFilter.value, TheMonth: courseFromDate.value, SalesID: 0 })

    headerJSON_1.value = [
      { Info: 'Monthly Sales Report - Personal by Daily', fs: 18 },
      { Info: 'Coach Name : ALL' },
      { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === centerFilter.value)].label}` },
      { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

      // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
      { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
      { Info: '' }, // Empty row
      { Info: '' }, // Empty row
      { Info: '' }, //  Empty row
      { Info: '' }, // Empty row
      { Info: '', bg: '#2F75B5' }, // for header row 5
    // #D9D9D9  other gray
    ]

    headerJSON_2.value = [
      { Info: 'Monthly Sales Report - Personal by Weekly', fs: 18 },
      { Info: 'Coach Name : ALL' },
      { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === centerFilter.value)].label}` },
      { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

      // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
      { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
      { Info: '' }, // Empty row
      { Info: '' }, // Empty row
      { Info: '' }, // for header row 5
      { Info: '', bg: '#2F75B5' }, // for header row 5
    // #D9D9D9  other gray
    ]
  }
})

watch(courseFromDate, newValue => {
  console.log('salesFilter.valuecourseFromDate', salesFilter.value)
  console.log('AllCenterArray', AllCenterArray)
  headerJSON_1.value = [
    { Info: 'Monthly Sales Report - Personal by Daily', fs: 18 },
    { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id == (salesFilter.value === false ? 0 : salesFilter.value))].label}` },
    { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === centerFilter.value)].label}` },
    { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

    // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
    { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
    { Info: '' }, // Empty row
    { Info: '' }, // Empty row
    { Info: '' }, //  Empty row
    { Info: '' }, // Empty row
    { Info: '', bg: '#2F75B5' }, // for header row 5
    // #D9D9D9  other gray
  ]

  headerJSON_2.value = [
    { Info: 'Monthly Sales Report - Personal by Weekly', fs: 18 },
    { Info: `Coach Name : ${salesList.value[salesList.value.findIndex(item => item.id === (salesFilter.value == false ? 0 : salesFilter.value))].label}` },
    { Info: `Center : ${AllCenterArray[AllCenterArray.findIndex(item => item.id === centerFilter.value)].label}` },
    { Info: `Date : ${moment(courseFromDate.value).format('MMMM')}` },

    // { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
    { Info: `Print Date : ${moment().format('YYYY-MM-DD HH:mm')}`, fs: 12 },
    { Info: '' }, // Empty row
    { Info: '' }, // Empty row
    { Info: '' }, // for header row 5
    { Info: '', bg: '#2F75B5' }, // for header row 5
    // #D9D9D9  other gray
  ]

  if (newValue) {
    callAPI({ CenterID: centerFilter.value,
      TheMonth: newValue,

      SalesID: salesList.value[salesList.value.findIndex(item => item.id === (salesFilter.value == false ? 0 : salesFilter.value))].id,

    })
  }
})

onMounted(() => {
  callSalesListAPI({ centerID: centerFilter.value })

  coachCenterList.value.push({
    id: 0,
    label: 'ALL',
  })

  //  initLuckysheet()
  ownCenterList().then(response => {
    console.log('response', response)

    // const firstItem = response.data.items[0].id

    for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      if (item) {
        coachCenterList.value.push({
          id: item.id,
          label: item.code,
        })
      }
    }

    // courseFromDate.value = getFirstDayOfMonth(moment().subtract(0, 'days').format('YYYY-MM-DD'))
    //  console.log('TheDate:' , new Date("2023-03-29 17:37:28"))
     

    if  ( coachCenterList.value.length > 2 ){
      AllCenter = 'ALL('
      console.log('coachCenterList.value[0].label1',coachCenterList.value[0].label)
 
      for (let index = 1; index < coachCenterList.value.length; index += 1) 
      {
        AllCenter +=  coachCenterList.value[index].label + ', ' 
        AllCenterArray.push({
          id: index,
          label: coachCenterList.value[index].label,
        })
      }
    
      AllCenter = AllCenter.slice(0, -2);
      AllCenter += ')'
      AllCenterArray[0].label = AllCenter
     
    }


//   

    console.log('AllCenterArrayasd', AllCenterArray)
    console.log('AllCenterArray[0].label',AllCenterArray[0].label)
                                          AllCenterArray[0].label
    courseFromDate.value = getFirstDayOfMonth(moment().subtract(30, 'days').format('YYYY-MM-DD'))
    
  //  centerFilter.value = false
//     setTimeout(function() {
  
// }, 3500);

  })

    .catch(err => {
      console.log('err', err)
    })
})

function handleCourseFromDateInput(dateValue) {
  console.log('dateValue', dateValue)
}

function handleCourseToDateInput(dateValue) {
  console.log('dateValue', dateValue)
}

function addBgToPreSecondLockerID(lockers) {
  let addColor = false // if true add color
  let tempID = 0
  try {
    tempID = lockers[0].lockerID
  } catch {

  }

  for (let i = 0; i < lockers.length; i++) {
    if (i == 0) {

    } else {
      if (lockers[i].lockerID != tempID) {
        addColor = !addColor
        tempID = lockers[i].lockerID
      }

      if (addColor) { lockers[i].bg = '#D9D9D9' }
    }
  }

  return lockers
}

function addBgToEverySecondRow(lockers) {
  for (let i = 0; i < lockers.length; i++) {
    if ((i % 2) != 0) { lockers[i].bg = '#D9D9D9' }
  }

  return lockers
}

function generateMergeJson(data, rowOffset, columnOffset) {
  const mergeJson = {}
  const mergeStart = {}
  const keysToMerge = ['lockerNo', 'lockerSize', 'lockerStatus', 'currentUser']

  data.forEach((row, i) => {
    let lockerIdMatch = true
    if (i === 0 || row.lockerID !== data[i - 1].lockerID) {
      lockerIdMatch = false
    }

    if (lockerIdMatch) {
      keysToMerge.forEach(key => {
        mergeStart[key] = (mergeStart[key] || 0) + 1
      })
    } else {
      keysToMerge.forEach((key, j) => {
        if (mergeStart[key] && mergeStart[key] > 1) {
          const mergeKey = `${i - mergeStart[key] + rowOffset}_${j + columnOffset}`
          mergeJson[mergeKey] = {
            rs: mergeStart[key],
            cs: 1,
            r: i - mergeStart[key] + rowOffset,
            c: j + columnOffset,
          }
        }
        mergeStart[key] = 1
      })
    }
  })

  keysToMerge.forEach((key, j) => {
    if (mergeStart[key] && mergeStart[key] > 1) {
      const mergeKey = `${data.length - mergeStart[key] + rowOffset}_${j + columnOffset}`
      mergeJson[mergeKey] = {
        rs: mergeStart[key],
        cs: 1,
        r: data.length - mergeStart[key] + rowOffset,
        c: j + columnOffset,
      }
    }
  })

  return mergeJson
}

function convertTimestamp(timestamp) {
  const momentObj = moment(timestamp)
  const formattedDate = momentObj.format('DD/MM/YYYY')
  const formattedTime = momentObj.format('hh:mm:ss A')

  return `${formattedDate} ${formattedTime}`
}

function convertTransactionDates(json) {
  json.forEach(obj => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && moment(obj[key], moment.ISO_8601).isValid()) {
        const momentObj = moment(obj[key])
        const formattedDate = momentObj.format('DD/MM/YYYY hh:mm:ss A')
        obj[key] = formattedDate
      }
    }
  })

  return json
}

function calculateColumnWidths(celldata) {
  const colWidths = {}

  celldata.forEach(cell => {
    const { c, v } = cell
    const content = v.v
    const fontSize = cell.v.fs ? cell.v.fs : 12

    // const width = content.toString().length * 10 * fontSize/10; // 10 is an approximate width per character
    // const width = content.toString().length *  fontSize /1.15;
    let width = content.toString().length * fontSize / 1.6
    if (width) {
      if (width <= 73) {
        width = 73
      }
    }

    if (!colWidths[c] || width > colWidths[c]) {
      colWidths[c] = width
    }
  })

  return colWidths
}

function calculateColumnHeights(celldata) {
  const colHeights = {}

  celldata.forEach(cell => {
    const { c, r } = cell

    // const content = v.v;
    // const lines = content.toString().split(/\r\n|\r|\n/).length; // Count the number of lines in the content
    const fontSize = cell.v.fs ? cell.v.fs : 12
    const lineHeight = fontSize * 1.2 // Calcula te the line height based on the font size, assuming 1.2x the font size as a standard
    const height = lineHeight

    if (!colHeights[r] || height > colHeights[r]) {
      colHeights[r] = height
    }
  })

  return colHeights
}

function jsonToCelldata(jsonData) {
  //  const checkWeekNumber = getWeeksInMonth()
  borderTable_2.value = []
  const date = moment(courseFromDate.value)
  const weeksInMonth = getWeeksInMonth(date)
  const weeksInYear = getWeekOfYear(date)
  const merge = []
  console.log('weeksInMonth', weeksInMonth) // Output: 5
  console.log('weeksInYear', weeksInYear) // Output: 5

  let firstRowHeader = ['', '', '', '']
  let secondRowHeader = ['', '', '', '']

  //  let firstRowHeader  = ['', ]
  //  let secondRowHeader  = ['', ]

  for (let i = 0; i < weeksInMonth; i++) {
    const numberheaders = [weeksInYear + i, '', '', '', '', '']
    firstRowHeader = [...firstRowHeader, ...numberheaders]
  }

  for (let i = 0; i < weeksInMonth; i++) {
    const numberheaders = [`Week ${(i + 1).toString()}`, '', '', '', '', '']
    secondRowHeader = [...secondRowHeader, ...numberheaders]
  }

  let headers = ['Center', 'Coach Name', 'Position', '']
  const fixOriginalheaders = ['Center', 'Coach Name', 'Position', '']
  const fixHeader = ['NEW', 'RENEW', 'FS', 'BR', 'Pit士多', 'Total']
  for (let i = 0; i < weeksInMonth; i++) {
    headers = [...headers, ...fixHeader]
  }

  // console.log('headers',headers)
  const celldata = []

  jsonData.forEach((item, row) => {
    if (row < 6) {
      // please check theitem.fs
      // const fs = value === undefined ? 12 : item.fs;

      const infoCell = {
        r: row,
        c: 0,
        v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info, fs: item.fs ? item.fs : 12 },
      }
      celldata.push(infoCell)
    } else if (row === 6) {
      firstRowHeader.forEach((header, c) => {
        // , bg : item.bg ? item.bg  : '#FFFFFFF'
        celldata.push({
          r: row,
          c,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header, ht: 0 },
        })
      })
    } else if (row === 7) {
      secondRowHeader.forEach((header, c) => {
        celldata.push({
          r: row,
          c,
          v: {
            m: header,
            ct: { fa: 'General', t: 's' },
            v: header,
            ht: 0,

          },

        })
      })
    } else if (row === 8) {
      headers.forEach((header, c) => {
        celldata.push({
          r: row,
          c,
          v: {
            m: header,
            ct: { fa: 'General', t: 's' },
            v: header,
            bg: item.bg ? item.bg : '#FFFFFFF',
            ht: 0,
            fc: '#FFFFFF',
          },

        })
      })
    }
  })

  const WeekData = weeklyData.value
 
  let TotalRow = 9
  let TempTotalRow = 9
  const TempRowArray = []

  const groupedData = WeekData.reduce((acc, cur) => {
    const { center } = cur
    if (!acc[center]) {
      acc[center] = []
    }
    acc[center].push(cur)

    return acc
  }, {})

  console.log('groupedData', groupedData)

  let centerCounter = 0

  centerCounter = Object.keys(groupedData).length

  console.log('centerCounter', centerCounter)

  Object.keys(groupedData).forEach(center => {
    console.log(`Center: ${center}`)

    groupedData[center].forEach((item, c) => {
      const rowData = [
        item.center,
        item.fullName,
        item.position,
        'Total',
        'Unit',
        item.weekly,

        // item.precentage ,
        // item.diff  ,
        // item.membershipName  ,
        //  item.course  ,
        //  item.originalCoach ,
        //  item.transferTo ,
        //  item.transferDate  ,
      ]

      rowData.forEach((value, c) => {
        console.log('rowData.forEach((value', value)
        let loopBool = false

        if (typeof value === 'object' && value !== null && value.constructor === Array) {
          console.log('myValue is an array')

          value.forEach((TheArrayValue, c) => {
            console.log('TheArrayValue', TheArrayValue)

            // NEW 0	RENEW	1 FS 2	BR 3	Pit士多 4	Total 5

            // money
            // weekNumber - startingWeek

            // const rowData = [
            //   TheArrayValue.Total,
            //   TheArrayValue.Unit,
            //   TheArrayValue.orderType,
            //   TheArrayValue.weekNumber,
            //   ];

            const weekDiff = TheArrayValue.weekNumber - startingWeek.value

            const columnOffset = 4
            const FinalColumnNumber = weeksInMonth * 6
            console.log('weekDiff', weekDiff)
            loopBool = !loopBool

            let internalSum = 5
            if (loopBool) {
              // loop finalColumnNumber length
              for (let i = 0; i < FinalColumnNumber; i++) {
                // if (i%5 && i != 0){
                //   sumCounter++
                // }

                if (i == 0) {
                  celldata.push(weekDataCellAdjust([], columnOffset, 0, TotalRow, i))
                  celldata.push(weekDataCellAdjust([], columnOffset, 0, TotalRow, i, 1))
                } else if (i == internalSum) {
                  // Total/Unit need create function
                  celldata.push(weekDataCellForTotal(TotalRow, i, fixOriginalheaders))
                  celldata.push(weekDataCellForTotal(TotalRow, i, fixOriginalheaders, 1))

                  internalSum += 6
                } else {
                  celldata.push(weekDataCellAdjust([], columnOffset, 0, TotalRow, i))
                  celldata.push(weekDataCellAdjust([], columnOffset, 0, TotalRow, i, 1))
                }
              }
            }

            const index1 = -1
            const index2 = -1

            switch (TheArrayValue.orderType.toLowerCase()) {
              case 'new':
                //  index1 = celldata.findIndex(theCell =>  theCell["r"] ==   TotalRow  && theCell["c"]==   columnOffset + 6 * weekDiff);
                // index2 = celldata.findIndex(theCell =>  theCell["r"] == TotalRow + 1 && theCell["c"]==  columnOffset + 6 * weekDiff);
                // if (index1 !== -1) {
                //   celldata.splice(index1, 1);
                // }
                // if (index2 !== -1) {
                //   celldata.splice(index2, 1);
                // }

                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow))
                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 0, 1))

                break
              case 'renew':
                //   index1 = celldata.findIndex(theCell =>  theCell["r"] ==   TotalRow  && theCell["c"]==  1 +  columnOffset + 6 * weekDiff);
                // index2 = celldata.findIndex(theCell =>  theCell["r"] == TotalRow + 1 && theCell["c"]==  1 + columnOffset + 6 * weekDiff);
                // if (index1 !== -1) {
                //   celldata.splice(index1, 1);
                // }
                // if (index2 !== -1) {
                //   celldata.splice(index2, 1);
                // }

                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 1))
                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 1, 1))

                break
              case 'fs':
                //   index1 = celldata.findIndex(theCell =>  theCell["r"] ==   TotalRow  && theCell["c"]==  2 +  columnOffset + 6 * weekDiff);
                // index2 = celldata.findIndex(theCell =>  theCell["r"] == TotalRow + 1 && theCell["c"]==  2 + columnOffset + 6 * weekDiff);
                // if (index1 !== -1) {
                //   celldata.splice(index1, 1);
                // }
                // if (index2 !== -1) {
                //   celldata.splice(index2, 1);
                // }

                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 2))
                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 2, 1))
                break
              case 'br':
                //   index1 = celldata.findIndex(theCell =>  theCell["r"] ==   TotalRow  && theCell["c"]==  3 +  columnOffset + 6 * weekDiff);
                // index2 = celldata.findIndex(theCell =>  theCell["r"] == TotalRow + 1 && theCell["c"]==  3 + columnOffset + 6 * weekDiff);
                // if (index1 !== -1) {
                //   celldata.splice(index1, 1);
                // }
                // if (index2 !== -1) {
                //   celldata.splice(index2, 1);
                // }

                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 3))
                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 3, 1))
                break
              case 'pit士多':
                //   index1 = celldata.findIndex(theCell =>  theCell["r"] ==   TotalRow  && theCell["c"]==  4 +  columnOffset + 6 * weekDiff);
                // index2 = celldata.findIndex(theCell =>  theCell["r"] == TotalRow + 1 && theCell["c"]==  4 + columnOffset + 6 * weekDiff);
                // if (index1 !== -1) {
                //   celldata.splice(index1, 1);
                // }
                // if (index2 !== -1) {
                //   celldata.splice(index2, 1);
                // }

                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 4))
                celldata.push(weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, 4, 1))
                break
              default:
                console.log('This is an unknown fruit.')
            }
          })
        } else {
          // console.log('myValue is not an array');
          // if (c == 0) {
          //   const stringValue = value === undefined ? '' : value.toString();
          //   const cell = {
          //     r: TotalRow + 1,
          //     c: c - 1,
          //     v: {
          //       m: stringValue,
          //       ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          //       v: stringValue,
          //       bg: '#BFBFBF'
          //     },
          //   };
          //   celldata.push(cell);
          // }   else

          // add color
          if (c == 0) {
            const stringValue = value === undefined ? '' : value.toString()
            console.log('stringValue', stringValue)
            const cell = {
              r: TotalRow,
              c,
              v: {
                m: stringValue,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: stringValue,
                bl: 1,

                // bg : item.bg ? item.bg : '#FFFFFF'
              },
            }
            celldata.push(cell)
          } else if (c == 2 || c == 1) {
            const stringValue = value === undefined ? '' : value.toString()
            const cell = {
              r: TotalRow,
              c,
              v: {
                m: stringValue,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: stringValue,
                bg: '#FFFF00',
                bl: 1,
              },

            }
            celldata.push(cell)

            const cell2 = {
              r: TotalRow + 1,
              c,
              v: {
                m: '',
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: '',
                bg: '#FFFF00',
                bl: 1,
              },

            }
            celldata.push(cell2)
            const afterborder = generateBorder(TotalRow, TotalRow + 1, c, c, 1, '#DFDFDF')
            console.log('afterborder ', afterborder)
            borderTable_2.value = [...borderTable_2.value, ...afterborder]
          } else if (c == 4) {
            const stringValue = value === undefined ? '' : value.toString()
            const cell = {
              r: TotalRow + 1,
              c: c - 1,
              v: {
                m: stringValue,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: stringValue,
                bg: '#BFBFBF',
              },
            }
            celldata.push(cell)
          }

          // Coach Name	Position add color

          else {
            // stringValue  TST/ Total/ TST

            const stringValue = value === undefined ? '' : value.toString()
            if (stringValue.toLowerCase() != 'unit') {
              console.log('stringValue', stringValue)
              const cell = {
                r: TotalRow,
                c,
                v: {
                  m: stringValue,
                  ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                  v: stringValue,

                  // bg : item.bg ? item.bg : '#FFFFFF'
                },
              }
              celldata.push(cell)
            }
          }
        }
      })

      TotalRow += 2

      // start from groupedData[center].forEach((item, c) => {
    })

    if (TotalRow - TempTotalRow >= 2) {
    // merge center column
      const key = `${TempTotalRow}_${0}` // This will create the key string "0_1"
      const obj = { rs: TotalRow - TempTotalRow, cs: 1, r: TempTotalRow, c: 0 }
      merge[key] = obj
    }

    // That Center Total/Unit footer
    const columnOffset = 4
    const FinalColumnNumber = weeksInMonth * 6 + 4

    // loop finalColumnNumber length
    for (let i = 0; i < FinalColumnNumber; i++) {
      celldata.push(weeklyFooter([], 0, 0, TotalRow, TempTotalRow, i))
      celldata.push(weeklyFooter([], 0, 0, TotalRow, TempTotalRow, i, 1))
      const afterborderForTop = generateWeelyFootBorder(TotalRow, TotalRow, 4, FinalColumnNumber, 1, '#000000', true)
      borderTable_2.value = [...borderTable_2.value, ...afterborderForTop]
      const afterborderFotBottom = generateWeelyFootBorder(TotalRow + 1, TotalRow + 1, 4, FinalColumnNumber, 1, '#000000', false, true)
      borderTable_2.value = [...borderTable_2.value, ...afterborderFotBottom]
    }

    const rowCounter = (TotalRow - TempTotalRow) / 2
    TempTotalRow += rowCounter * 2 + 2

    TempRowArray.push(TempTotalRow)

    TotalRow += 2

    console.log('celldata', celldata)
  })

  // Grand Footer
  // color #C65911
  console.log('TempRowArray', TempRowArray)

  // That Center Total/Unit footer
  const columnOffset = 4
  const FinalColumnNumber = weeksInMonth * 6 + 4

  if (centerCounter != 0) {
    // loop finalColumnNumber length
    for (let i = 0; i < FinalColumnNumber; i++) {
      celldata.push(weeklyGrandFooter(TempRowArray, 0, 0, TempRowArray[TempRowArray.length - 1], TempRowArray[TempRowArray.length - 1], i, 0, '#C65911'))
      celldata.push(weeklyGrandFooter(TempRowArray, 0, 0, TempRowArray[TempRowArray.length - 1], TempRowArray[TempRowArray.length - 1], i, 1, '#C65911'))
      const afterborderForTop = generateWeelyFootBorder(TotalRow, TotalRow, 4, FinalColumnNumber, 1, '#000000', true)
      borderTable_2.value = [...borderTable_2.value, ...afterborderForTop]
      const afterborderFotBottom = generateWeelyFootBorder(TotalRow + 1, TotalRow + 1, 4, FinalColumnNumber, 1, '#000000', false, true)
      borderTable_2.value = [...borderTable_2.value, ...afterborderFotBottom]
    }
  }

  // console.log('merge2',merge)
  merge_2.value = merge

  return celldata
}

function jsonToCelldataForDaily(jsonData) {
  //  const checkWeekNumber = getWeeksInMonth()
  borderTable_1.value = []
  const date = moment(courseFromDate.value)
  console.log('firstdate', courseFromDate.value)
  const weeksInMonth = getWeeksInMonth(date)
  const weeksInYear = getWeekOfYear(date)
  const daysInMonth = date.daysInMonth()
  const merge = []

  const firstRowHeader = []
  const secondRowHeader = []
  const thirdRowHeader = []
  const firstDayOfMonth = date.startOf('month').format('DD-MM-YYYY')

  let rememberTotalRow = []

  // getweek
  // day 2023-05-01 , 2023-05-02
  // Mon, Tue, Wed, Thu, Fri ...
  for (let i = 0; i < daysInMonth; i++) {
    const thedateHeader = date.startOf('month').add(i, 'days').format('DD-MM-YYYY')
    const thedate = date.startOf('month').add(i, 'days')
    const theDayFormat = thedate.format('ddd')
    const theWeekHeader = thedate.week()
    console.log('thedate', theWeekHeader)
    firstRowHeader.push(theWeekHeader)
    secondRowHeader.push(thedateHeader)
    thirdRowHeader.push(theDayFormat)
  }
  console.log('daysInMonth', daysInMonth)

  // console.log('firstRowHeader',firstRowHeader)
  const emptyHeaderIndex = 8
  const originalHeaders = ['Center', 'Coach Name', 'Position', 'Target', '100%', 'Diff', '%', '', 'New', 'Renew', 'FS', 'BR', 'MTD', 'Pit士多']
  let headers = ['Center', 'Coach Name', 'Position', 'Target', '100%', 'Diff', '%', '', 'New', 'Renew', 'FS', 'BR', 'MTD', 'Pit士多']
  const fixHeader = ['NEW', 'RENEW', 'FS', 'BR', 'Pit士多', 'Total']
  const loopHeader = ['NEW', 'RENEW', 'FS', 'BR', 'Pit士多']
  for (let i = 0; i < daysInMonth; i++) {
    headers = [...headers, ...loopHeader]
  }

  // console.log('headerssa',headers)
  const celldata = []

  jsonData.forEach((item, row) => {
    if (row < 5) {
      // please check theitem.fs
      // const fs = value === undefined ? 12 : item.fs;

      const infoCell = {
        r: row,
        c: 0,
        v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info, fs: item.fs ? item.fs : 12 },
      }
      celldata.push(infoCell)
    } else if (row === 6) {
      let counterForRow = 0
      console.log('firstRowHeader', firstRowHeader)
      firstRowHeader.forEach((header, c) => {
        celldata.push({
          r: row,
          c: originalHeaders.length + counterForRow * loopHeader.length,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header, ht: 0 },
          ht: 0,
        })
        const key = `${row}_${originalHeaders.length + counterForRow * loopHeader.length}` // This will create the key string "0_1"
        const obj = { rs: 1, cs: 5, r: row, c: originalHeaders.length + counterForRow * loopHeader.length }
        merge[key] = obj
        counterForRow += 1
      })
    } else if (row === 7) {
      let counterForRow = 0

      secondRowHeader.forEach((header, c) => {
        celldata.push({
          r: row,
          c: originalHeaders.length + counterForRow * loopHeader.length,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header, ht: 0 },
          ht: 0,
        })
        const key = `${row}_${originalHeaders.length + counterForRow * loopHeader.length}` // This will create the key string "0_1"
        const obj = { rs: 1, cs: 5, r: row, c: originalHeaders.length + counterForRow * loopHeader.length }
        merge[key] = obj
        counterForRow += 1
      })

      // borderTable_1.value = [...borderTable_1.value,
      // ...generateOutsideBorderWithRange(row, row + 1, originalHeaders.length,
      //   originalHeaders.length + counterForRow * loopHeader.length, 13, "#000", loopHeader.length)];
      const sliceArray = headers.slice(originalHeaders.length)

      // console.log('borderResult' , generateTotalBorder(TempTotalRow - 1  , fixHeader.length, sliceArray ))

      const borderStyle = { style: 13, color: '#000' }

      // To prevent miss border bug after merge
      const borderInfo = []
      borderInfo.push({
        rangeType: 'cell',
        value: {
          row_index: row,
          col_index: originalHeaders.length - 1,
          r: borderStyle,

        },
      })
      borderInfo.push({
        rangeType: 'cell',
        value: {
          row_index: row + 1,
          col_index: originalHeaders.length - 1,
          r: borderStyle,

        },
      })
      borderTable_1.value = [...borderTable_1.value,
        ...borderInfo]

      borderTable_1.value = [...borderTable_1.value,
        ...generateTotalBorder(row, originalHeaders.length, sliceArray, { hideBottom: true })]

      borderTable_1.value = [...borderTable_1.value,
        ...generateTotalBorder(row + 1, originalHeaders.length, sliceArray, { hideTop: true })]
    } else if (row === 8) {
      let counterForRow = 0

      thirdRowHeader.forEach((header, c) => {
        celldata.push({
          r: row,
          c: originalHeaders.length + counterForRow * loopHeader.length,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header, ht: 0 },
          ht: 0,

          // l: {style:1 , color :"#DFDFDF"}
        })
        const key = `${row}_${originalHeaders.length + counterForRow * loopHeader.length}` // This will create the key string "0_1"
        const obj = { rs: 1, cs: 5, r: row, c: originalHeaders.length + counterForRow * loopHeader.length }
        merge[key] = obj
        counterForRow += 1
      })
    } else if (row === 9) {
      // render   originalHeaders = ['Center', 'Coach Name', 'Position', 'Target', '100%', 'Diff', '%', '' , 'New', 'Renew', 'FS', 'BR', 'MTD', 'Pit士多'];
      const counterForCol = 0
      originalHeaders.forEach((header, c) => {
        celldata.push({
          r: row,
          c,
          v: { m: header,
            ct: { fa: 'General', t: 's' },
            v: header,
            ht: 0,
            bg: '#0070C0',
            fc: '#FFFFFF' },
        })
      })

      // let loopHeader = ['NEW', 'RENEW', 'FS', 'BR', 'Pit士多']
      let newLoopHeader = []
      console.log('secondRowHeader', secondRowHeader.length) // loop times

      for (let i = 0; i < secondRowHeader.length; i++) {
        newLoopHeader = [...newLoopHeader, ...loopHeader]
      }

      newLoopHeader.forEach((header, c) => {
        celldata.push({
          r: row,
          c: originalHeaders.length + c,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header, ht: 0, bg: '#0070C0', fc: '#FFFFFF' },
        })
      })
    }
  })

  // daily
  const WeekData = weeklyData.value

  // currentrow
  let TotalRow = 10
  let TempTotalRow = 10
  const TempRowArray = []
  console.log('groupedData', WeekData)
  const groupedData = WeekData.reduce((acc, cur) => {
    const { center } = cur
    if (!acc[center]) {
      acc[center] = []
    }
    acc[center].push(cur)

    return acc
  }, {})

  console.log('groupedData', groupedData)

  let centerCounter = 0

  centerCounter = Object.keys(groupedData).length

  console.log('centerCounter', centerCounter)

  Object.keys(groupedData).forEach(center => {
    console.log(`Center: ${center}`)

    //  console.log('groupedDataDaily',groupedData[center])

    groupedData[center].forEach((item, c) => {
      const rowData = [
        item.center,
        item.fullName,
        item.position,
        item.salesTarget,
        '100%',
        'Diff',
        '%',
        'Total',
        'Unit',
        item.weekly,

        // item.precentage ,
        // item.diff  ,
        // item.membershipName  ,
        //  item.course  ,
        //  item.originalCoach ,
        //  item.transferTo ,
        //  item.transferDate  ,
      ]

      console.log('item.salesTarget',item.salesTarget)

      rowData.forEach((value, c) => {
        console.log('rowData.forEach((value', value)
        let loopBool = false

        if (typeof value === 'object' && value !== null && value.constructor === Array) {
          console.log('myValue is an array')

          value.forEach((TheArrayValue, c) => {
            console.log('TheArrayValue', TheArrayValue)

            // NEW 0	RENEW	1 FS 2	BR 3	Pit士多 4

            // const weekDiff = TheArrayValue.weekNumber - startingWeek.value

            const columnOffset = originalHeaders.length
            const FinalColumnNumber = daysInMonth * 5

            loopBool = !loopBool
            if (loopBool) {
              // loop finalColumnNumber length
              // fill all 0 in table
              for (let i = 0; i < FinalColumnNumber; i++) {
                celldata.push(dailyDataCellAdjust([], columnOffset, 0, TotalRow, loopHeader.length, i))
                celldata.push(dailyDataCellAdjust([], columnOffset, 0, TotalRow, loopHeader.length, i, 1, '#BFBFBF'))
              }
            }

            const index1 = -1
            const index2 = -1

            console.log('TheArrayValue', TheArrayValue)
            const daysDiff = moment(TheArrayValue.cr_date).date() - 1

            // const daysDiff = moment('2023-05-01T00:00:00.000Z').date();
            // NEW 0	RENEW	1 FS 2	BR 3	Pit士多 4
            switch (TheArrayValue.orderType.toLowerCase()) {
              case 'new':
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5))
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 0, 1))
                break
              case 'renew':
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 1))
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 1, 1))
                break
              case 'fs':
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 2))
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 2, 1))
                break
              case 'br':
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 3))
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 3, 1))
                break
              case 'pit士多':
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 4))
                celldata.push(dailyDataCellAdjust(TheArrayValue, columnOffset, daysDiff, TotalRow, 5, 4, 1))
                break
              default:
                console.log('This is an unknown fruit.')
            }
          })
        } else {
          // console.log('myValue is not an array');

          if (c == 0) {
            const stringValue = value === undefined ? '' : value.toString()
            console.log('stringValue', stringValue)
            const cell = {
              r: TotalRow,
              c,
              v: {
                m: stringValue,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: stringValue,
                bl: 1,

                // bg : item.bg ? item.bg : '#FFFFFF'
              },
            }
            celldata.push(cell)
          }

          // Show Target
          if (c == 3) {
            const stringValue = value === undefined ? 1 : value.toString()

            const cell = {
              r: TotalRow,
              c,
              v: {
                m: stringValue,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: stringValue,

                // bg : item.bg ? item.bg : '#FFFFFF'
                ht: 2,
              },

            }
            celldata.push(cell)
          }

          // Show 100% can be changed by user
          if (c == 4) {
            const tempRow = TotalRow + 1
            const theFunction = `=D${tempRow}*$E$10`
            console.log('theFunction', theFunction)
            const cell = {
              r: TotalRow,
              c,
              v: {
                f: theFunction,
                m: '',
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: '',
                ht: 2,
              },
            }
            celldata.push(cell)

            const a = [
              {
                r: TotalRow, // the number of rows
                c, // the number of columns
                index: '0', // sheet id
                func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
                color: 'w', // "w"：use Depth-First-Search "b":Normal search
                parent: null,
                chidren: {},
                times: 0,
              },
            ]
            calcChain_1.value = [...calcChain_1.value, ...a]
            console.log('calcChain_1.value', calcChain_1.value)
          }

          // Diff
          if (c == 5) {
            const tempRow = TotalRow + 1
            const theFunction = `=M${tempRow}-E${tempRow}`
            console.log('theFunction', theFunction)
            const cell = {
              r: TotalRow,
              c,
              v: {
                f: theFunction,
                m: '',
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: '',
                ht: 2,
              },
            }
            celldata.push(cell)

            const a = [
              {
                r: TotalRow, // the number of rows
                c, // the number of columns
                index: '0', // sheet id
                func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
                color: 'w', // "w"：use Depth-First-Search "b":Normal search
                parent: null,
                chidren: {},
                times: 0,
              },
            ]
            calcChain_1.value = [...calcChain_1.value, ...a]
            console.log('calcChain_1.value', calcChain_1.value)
          }

          // %
          if (c == 6) {
            const tempRow = TotalRow + 1
            const theFunction = `=M${tempRow}/D${tempRow}`
            console.log('theFunction', theFunction)
            const cell = {
              r: TotalRow,
              c,
              v: {
                f: theFunction,
                m: '',
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: '',
                ht: 2,
              },
            }
            celldata.push(cell)

            const a = [
              {
                r: TotalRow, // the number of rows
                c, // the number of columns
                index: '0', // sheet id
                func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
                color: 'w', // "w"：use Depth-First-Search "b":Normal search
                parent: null,
                chidren: {},
                times: 0,
              },
            ]
            calcChain_1.value = [...calcChain_1.value, ...a]
            console.log('calcChain_1.value', calcChain_1.value)
          }

          //
          if (c == 7) {
            const cell = {
              r: TotalRow,
              c,
              v: {
                m: value,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: value,
                ht: 1,
              },
            }
            celldata.push(cell)
          }

          // Show  New	Renew	FS	BR	MTD	Pit士多 sum value
          if (c == 8) {
            const cell = {
              f: '=',
              r: TotalRow + 1,
              c: c - 1,
              v: {
                m: value,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: value,
                bg: '#BFBFBF',
                ht: 1,
              },

            }
            celldata.push(cell)

            // forsum other  New	Renew	FS	BR	MTD	Pit士多
            console.log('secondRowHeader', secondRowHeader.length) // loop times July 31 times

            //      0   1     2   3       5
            const array = [0, 1, 2, 3, 4]

            // loop  New	Renew	FS	BR and 	Pit士多
            for (let ii = 0; ii < array.length; ii++) {
              // loop next line
              for (let iii = 0; iii <= 1; iii++) {
                let theFunction = '='
                for (let i = 0; i < secondRowHeader.length; i++) {
                  theFunction += createExcelColumnMap(originalHeaders.length + 5 * i + array[ii])
                  theFunction += (TotalRow + 1 + iii)
                  if ((i != secondRowHeader.length - 1)) {
                    theFunction += ' + '
                  }
                }

                const cell = {
                  r: TotalRow + iii,
                  c: (ii == 4 ? c + ii + 1 : c + ii),
                  v: {
                    f: theFunction,
                    m: '',
                    ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                    v: '',
                    ht: 2,

                    ...iii == 1 && { bg: '#BFBFBF' },
                  },
                }
                celldata.push(cell)

                const a = [
                  {
                    r: TotalRow + iii, // the number of rows
                    c: (ii == 4 ? c + ii + 1 : c + ii),
                    index: '0', // sheet id
                    func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
                    color: 'w', // "w"：use Depth-First-Search "b":Normal search
                    parent: null,
                    chidren: {},
                    times: 0,
                  },
                ]
                calcChain_1.value = [...calcChain_1.value, ...a]
              }
            }

            //= SUM(I10:L10)
            // const originalHeaders = ['Center', 'Coach Name', 'Position', 'Target', '100%',
            // 'Diff', '%', '', 'New', 'Renew', 'FS', 'BR', 'MTD', 'Pit士多'];
            // find New
            const targetNewIndex = originalHeaders.findIndex(record => record === 'New')
            const NewCol = createExcelColumnMap(targetNewIndex)

            // Find BR prevent add more column before MTD , so do not use BR
            const targetBRIndex = originalHeaders.findIndex(record => record === 'MTD') - 1
            const BRCol = createExcelColumnMap(targetBRIndex)

            const MTDIndex = originalHeaders.findIndex(record => record === 'MTD')

            for (let i = 0; i <= 1; i++) {
              const MTDFunction = `=SUM(${NewCol}${TotalRow + i + 1}:${BRCol}${TotalRow + i + 1})`
              console.log('MTDFunction', MTDFunction)

              //  for MTD
              const MTDCell = {
                r: TotalRow + i,
                c: MTDIndex,
                v: {
                  f: MTDFunction,
                  m: '',
                  ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                  v: '',
                  ht: 2,
                  ...i == 1 && { bg: '#BFBFBF' },
                },
              }
              celldata.push(MTDCell)

              const a = [
                {
                  r: TotalRow + i,
                  c: MTDIndex,
                  index: '0', // sheet id
                  func: [true, 0, MTDFunction], // Formula information, including formula calculation results and formula string
                  color: 'w', // "w"：use Depth-First-Search "b":Normal search
                  parent: null,
                  chidren: {},
                  times: 0,
                },
              ]
              calcChain_1.value = [...calcChain_1.value, ...a]
            }
          }

          // Coach Name	Position
          if (c == 2 || c == 1) {
            const stringValue = value === undefined ? '' : value.toString()
            const cell = {
              r: TotalRow,
              c,
              v: {
                m: stringValue,
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: stringValue,
                bg: '#FFFF00',
                bl: 1,
              },

            }
            celldata.push(cell)

            const cell2 = {
              r: TotalRow + 1,
              c,
              v: {
                m: '',
                ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                v: '',
                bg: '#FFFF00',
                bl: 1,
              },

            }
            celldata.push(cell2)
            const afterborder = generateBorder(TotalRow, TotalRow + 1, c, c, 1, '#DFDFDF')
            console.log('afterborder ', afterborder)
            borderTable_1.value = [...borderTable_1.value, ...afterborder]
          }
        }
      })

      TotalRow += 2

      // start from groupedData[center].forEach((item, c) => {
    })

    // That Center Total/Unit footer
    // const columnOffset = 4
    // let FinalColumnNumber = weeksInMonth * 6 + 4
    // const originalHeaders = ['Center', 'Coach Name', 'Position', 'Target', '100%', 'Diff', '%',
    // '', 'New', 'Renew', 'FS', 'BR', 'MTD', 'Pit士多'];

    rememberTotalRow = [...rememberTotalRow , TotalRow + 2]
    console.log('rememberTotalRow',rememberTotalRow)

    const columnOffset = originalHeaders.length
    const FinalColumnNumber = daysInMonth * 5 + originalHeaders.length

    // for sum NEW	RENEW	FS	BR 13
    let sumCounter = 0
    let findfirstindex = originalHeaders.length

    // loop finalColumnNumber length
    for (let i = 0; i < FinalColumnNumber; i++) {
      celldata.push(dailyFooter(originalHeaders, [], 0, 0, TotalRow, TempTotalRow, { OrderTypeOffset: i, index: '0' }))
      celldata.push(dailyFooter(originalHeaders, [], 0, 0, TotalRow, TempTotalRow, { OrderTypeOffset: i, nextRowOffset: 1, index: '0' }))

      if (sumCounter == 0 && i == findfirstindex) {
        console.log('sumCounter == 0thei', i)
        celldata.push(dailyFooterSum(TotalRow + 2, findfirstindex + 2, {}))
        findfirstindex += loopHeader.length
        sumCounter += 1
      } else if (sumCounter != 0 && i == findfirstindex) {
        celldata.push(dailyFooterSum(TotalRow + 2, findfirstindex + 2, {}))
        findfirstindex += loopHeader.length

        console.log('thei', i)
      }
 
    }

    //center merge
    if (TotalRow - TempTotalRow >= 2) {
    // merge center column
      const key = `${TempTotalRow}_${0}` // This will create the key string "0_1"
      const obj = { rs: TotalRow - TempTotalRow, cs: 1, r: TempTotalRow, c: 0 }
      merge[key] = obj
    }

    const rowCounter = (TotalRow - TempTotalRow) / 2

    // every 2 * rowCounter + 3 offset
    TempTotalRow += rowCounter * 2 + 3

    let counterForRow = 0

    secondRowHeader.forEach((header, c) => {
      counterForRow += 1
    })
    const sliceArray = headers.slice(originalHeaders.length)
    console.log('originalHeaders.length', originalHeaders)
    console.log('sliceArray', sliceArray)

    // console.log('borderResult' , generateTotalBorder(TempTotalRow - 1  , fixHeader.length, sliceArray ))
    //center footer border
    borderTable_1.value = [...borderTable_1.value,
      ...generateTotalBorder(TempTotalRow - 1, originalHeaders.length, sliceArray, {})]

    // TempRowArray.push(TempTotalRow)

    TotalRow += 3

    console.log('celldata', celldata)
  })


  const grandTotalOffset = 3

//daily Grand Footer
  // Grand Footer
  // color #C65911
  console.log('rememberTotalRowlength', rememberTotalRow )

  // That Center Total/Unit footer
  const columnOffset = 3
  const FinalColumnNumber = daysInMonth * 5 + originalHeaders.length
  // emptyHeaderIndex
console.log('TempRowArray', TempRowArray)
 let sumCounter = 0 
 let findfirstindex = originalHeaders.length


  if (centerCounter != 0) {
    // loop finalColumnNumber length
    for (let i = 0; i < FinalColumnNumber; i++) {
      celldata.push(dailyGrandFooter(rememberTotalRow , 0, 0, rememberTotalRow[rememberTotalRow.length -1] + grandTotalOffset ,  i, 0, '#C65911'));
      celldata.push(dailyGrandFooter(rememberTotalRow , 0, 0, rememberTotalRow[rememberTotalRow.length -1] + grandTotalOffset ,  i, 1, '#C65911'));
      // const afterborderForTop = generateWeelyFootBorder(TotalRow, TotalRow, 4, FinalColumnNumber, 1, "#000000", true)
      // borderTable_1.value = [...borderTable_1.value, ...afterborderForTop]
      // const afterborderFotBottom = generateWeelyFootBorder(TotalRow + 1, TotalRow + 1, 4, FinalColumnNumber, 1, "#000000", false, true)
      // borderTable_1.value = [...borderTable_1.value, ...afterborderFotBottom]

      if (sumCounter == 0 && i == findfirstindex) {
        console.log('sumCounter == 0thei', i)
        celldata.push(dailyFooterSum(rememberTotalRow[rememberTotalRow.length -1] + grandTotalOffset + 2, findfirstindex + 2, {}))
        findfirstindex += loopHeader.length
        sumCounter += 1
      } else if (sumCounter != 0 && i == findfirstindex) {
        celldata.push(dailyFooterSum(rememberTotalRow[rememberTotalRow.length -1] + grandTotalOffset + 2, findfirstindex + 2, {}))
        findfirstindex += loopHeader.length

        console.log('thei', i)
      }


    }


    const sliceArray = headers.slice(originalHeaders.length)
    borderTable_1.value = [...borderTable_1.value,
      ...generateTotalBorder(rememberTotalRow[rememberTotalRow.length -1] + 2 + grandTotalOffset , originalHeaders.length, sliceArray, {})]
  }
  // dailyGrandFooter(rememberTotalRow[rememberTotalRow.length - 1 ] , )
 
       

  // if (centerCounter != 0) {
  //   // loop finalColumnNumber length
  //   for (let i = 0; i < FinalColumnNumber; i++) {
  //     celldata.push(weeklyGrandFooter(TempRowArray, 0, 0, TempRowArray[TempRowArray.length - 1], TempRowArray[TempRowArray.length - 1], i, 0, '#C65911'))
  //     celldata.push(weeklyGrandFooter(TempRowArray, 0, 0, TempRowArray[TempRowArray.length - 1], TempRowArray[TempRowArray.length - 1], i, 1, '#C65911'))
  //     const afterborderForTop = generateWeelyFootBorder(TotalRow, TotalRow, 4, FinalColumnNumber, 1, '#000000', true)
  //     borderTable_1.value = [...borderTable_1.value, ...afterborderForTop]
  //     const afterborderFotBottom = generateWeelyFootBorder(TotalRow + 1, TotalRow + 1, 4, FinalColumnNumber, 1, '#000000', false, true)
  //     borderTable_1.value = [...borderTable_1.value, ...afterborderFotBottom]
  //   }
  // }
 


  // //Grand Footer
  // //color #C65911
  // console.log('TempRowArray', TempRowArray)
  // //That Center Total/Unit footer
  // const columnOffset = 4
  // let FinalColumnNumber = weeksInMonth * 6 + 4

  // if (centerCounter != 0) {
  //   //loop finalColumnNumber length
  //   for (let i = 0; i < FinalColumnNumber; i++) {
  //     celldata.push(weeklyGrandFooter(TempRowArray, 0, 0, TempRowArray[TempRowArray.length - 1], TempRowArray[TempRowArray.length - 1], i, 0, '#C65911'));
  //     celldata.push(weeklyGrandFooter(TempRowArray, 0, 0, TempRowArray[TempRowArray.length - 1], TempRowArray[TempRowArray.length - 1], i, 1, '#C65911'));
  //     const afterborderForTop = generateWeelyFootBorder(TotalRow, TotalRow, 4, FinalColumnNumber, 1, "#000000", true)
  //     borderTable_1.value = [...borderTable_1.value, ...afterborderForTop]
  //     const afterborderFotBottom = generateWeelyFootBorder(TotalRow + 1, TotalRow + 1, 4, FinalColumnNumber, 1, "#000000", false, true)
  //     borderTable_1.value = [...borderTable_1.value, ...afterborderFotBottom]
  //   }
  // }

  merge_1.value = merge

  return celldata
}

function initLuckysheet(data, data_2) {
  console.log('Sheet loaded')

  // console.log('jsonToCelldata(data);', data)
  console.log('datadatadata', data)
  const celldata_1 = jsonToCelldataForDaily(data)
  const colWidths_1 = calculateColumnWidths(celldata_1)

  const colHeights_1 = calculateColumnHeights(celldata_1)

  // #region datesheet 2 for weekly
  const celldata_2 = jsonToCelldata(data_2)
  const colWidths_2 = calculateColumnWidths(celldata_2)
  console.log('initLuckysheetcolWidths', colWidths_2)
  const colHeights_2 = calculateColumnHeights(celldata_2)
  console.log('colHeights', colHeights_2)

  const date = moment(courseFromDate.value)
  const weeksInMonth = getWeeksInMonth(date)
  const weeksInYear = getWeekOfYear(date)
  borderTable_2.value = [...borderTable_2.value, ...generateOutsideBorderInfo(6, 7, 4, 3 + 6 * weeksInMonth, 13, '#000')]

  // #endregion
  console.log('celldata_1', celldata_1)
  console.log('calcChain_2x', calcChain_2.value)
  const options = {
    container: 'luckysheet',
    title: 'Locker',
    lang: 'zh',

    showsheetbar: true,
    forceCalculation: true,
    data: [
      {
        name: 'Personal - Daily',
        status: 1,
        index: '0',
        celldata: celldata_1,
        calcChain: calcChain_1.value,
        config: {
          authority: { // 当前工作表的权限配置
            sheet: 1, // sheet表下标。
            hintText: 'You can not edit any cell', // 弹窗提示的文字
          },
          rowlen: {}, // Table row height
          columnlen: colWidths_1,
          rowlen: colHeights_1, // Table row height
          rowhidden: {}, // hidden rows
          colhidden: {}, // hidden columns
          merge: merge_1.value,
          borderInfo: borderTable_1.value,

        },
      },
      {
        name: 'Personal - Weekly',
        status: 1,
        index: '1',
        celldata: celldata_2,
        calcChain: calcChain_2.value,
        config: {
          authority: { // 当前工作表的权限配置
            sheet: 2, // sheet表下标。
            hintText: 'You can not edit any cell', // 弹窗提示的文字
          },
          rowlen: {}, // Table row height
          columnlen: colWidths_2,
          rowlen: colHeights_2, // Table row height
          rowhidden: {}, // hidden rows
          colhidden: {}, // hidden columns
          borderInfo: borderTable_2.value,
          merge: merge_2.value,

        },
      },
    ],
  }

  return options
}

function callSalesListAPI(data) {
  // salesList.value = []

  const templist = []
  templist.push({
    id: 0,
    label: 'ALL',

  })

  return new Promise((resolve, reject) => {
    fetchSales(data).then(response => {
      console.log('response', response)

      for (let index = 0; index < response.data.items.length; index += 1) {
        const item = response.data.items[index]
        console.log('callSalesListAPI', item)
        if (item) {
          templist.push({
            id: item.id,
            label: item.fullname,
          })
        }
      }
      console.log('tempSalesList', templist)

      salesList.value = templist

      salesFilterConfig.value = {
        name: 'salesFilter',
        label: 'Sales',
        type: {
          name: 'autocomplete',
          items: salesList.value,
        },
      }
      resolve(templist)
    }).catch(err => { reject(error) })
  })
}

function callAPI(data) {
  const a = getFirstDayOfMonth(moment(data.TheMonth).subtract(0, 'days').format('YYYY-MM-DD'))
  showExcel(data)
    .then(lockerExcelresponse => {
      // console.log('lockerExcelresponse',lockerExcelresponse)
      let newArray = lockerExcelresponse.data.record

      weeklyData.value = convertJsonForWeek(lockerExcelresponse.data.record)
      console.log('weeklyData.value', weeklyData.value)

      // console.log('newArray',newArray)

      // newArray is SourceData
      newArray = addBgToEverySecondRow(newArray)
      newArray = convertTransactionDates(newArray)

      TempData_2.value = [...headerJSON_2.value, ...newArray]
      TempData_1.value = [...headerJSON_1.value, ...newArray]

      const temp = initLuckysheet(TempData_1.value, TempData_2.value)
      console.log('temp', temp)
      importData.value = temp

      // initLuckysheet(newValue)
    })

    .catch(err => {
      console.log('err', err)
    })
}

function getWeeksInMonth(date) {
  const year = date.year()
  const month = date.month()

  // Create a new moment object for the first day of the month
  const firstDayOfMonth = moment([year, month, 1])

  // Find the number of days in the month
  const daysInMonth = moment([year, month]).daysInMonth()

  // Find the number of days before the first Sunday
  const firstSunday = 7 - firstDayOfMonth.day()

  // Subtract the number of days before the first Sunday from the total number of days in the month
  const daysLeftInMonth = daysInMonth - firstSunday

  // Calculate the number of weeks in the month
  const weeksInMonth = Math.ceil(daysLeftInMonth / 7) + 1

  return weeksInMonth
}

function getWeekOfYear(date) {
  // Create a Moment object from the input date
  const momentDate = moment(date)

  // Get the week number of the input date
  const weekOfYear = momentDate.isoWeek()

  return weekOfYear
}

function generateOutsideBorderInfo(startRow, endRow, startCol, endCol, style, color, divider = 6) {
  const borderStyle = {
    style,
    color,
  }

  const borderInfo = []
  let counter = 0

  // Top and bottom borders
  for (let col = startCol; col <= endCol; col++) {
    // console.log('colcol',col)

    borderInfo.push({
      rangeType: 'cell',
      value: {
        row_index: startRow,
        col_index: col,
        t: borderStyle,
        ...(col === startCol || (counter % divider == 0) ? { l: borderStyle } : {}), // Add left border for the top-left cell
        ...(col === endCol ? { r: borderStyle } : {}), // Add right border for the top-right cell
      },
    })

    borderInfo.push({
      rangeType: 'cell',
      value: {
        row_index: endRow,
        col_index: col,
        b: borderStyle,
        ...(col === startCol || (counter % divider == 0) ? { l: borderStyle } : {}), // Add left border for the bottom-left cell
        ...(col === endCol ? { r: borderStyle } : {}), // Add right border for the bottom-right cell
      },
    })
    counter++
  }

  // Left and right borders
  // for (var row = startRow + 1; row < endRow; row++) {
  //   borderInfo.push({
  //     "rangeType": "cell",
  //     "value": {
  //       "row_index": row,
  //       "col_index": startCol,
  //       "l": borderStyle
  //     }
  //   });

  //   borderInfo.push({
  //     "rangeType": "cell",
  //     "value": {
  //       "row_index": row,
  //       "col_index": endCol,
  //       "r": borderStyle
  //     }
  //   });
  // }

  return borderInfo
}

function generateTotalBorder(startRow, offsetCol, loopHeader, { style = 13, color = '#000', hideBottom = false, hideTop = false }) {
  const borderStyle = {
    style,
    color,
  }

  const newHeader = loopHeader.map(item => {
    if (item.toLowerCase() === 'new') {
      return 1
    } if (item.toLowerCase().includes('pit')) {
      return 2
    }

    return 0
  })

  console.log('generateTotalBorder', newHeader)

  const borderInfo = []
  const counter = 0

  // Top and bottom borders
  for (let col = 0; col < newHeader.length; col++) {
    // console.log('colcol',col)

    borderInfo.push({
      rangeType: 'cell',
      value: {
        row_index: startRow,
        col_index: offsetCol + col,

        ...(newHeader[col] == 1 ? { l: borderStyle } : {}), // Add left border
        ...(newHeader[col] == 2 ? { r: borderStyle } : {}), // Add left border

        ...(!hideTop == true ? { t: borderStyle } : {}),
        ...(!hideBottom == true ? { b: borderStyle } : {}),

      },
    })
  }

  return borderInfo
}

function generateOutsideBorderWithRange(startRow, endRow, startCol, endCol, style, color, divider = 6) {
  const borderStyle = {
    style,
    color,
  }

  const borderInfo = []
  const counter = 0

  // Top and bottom borders
  for (let col = startCol; col < endCol; col++) {
    // console.log('colcol',col)

    borderInfo.push({
      rangeType: 'range',
      borderType: 'border-all',
      style,
      color,
      range: [{
        row: [startRow, endRow],
        column: [startCol, col],
      }],
    })
  }

  return borderInfo
}

function generateBorder(startRow, endRow, startCol, endCol, style, color) {
  const borderStyle = {
    style,
    color,
  }

  const borderInfo = []
  let counter = 0

  // Top and bottom borders
  for (let col = startCol; col <= endCol; col++) {
    // console.log('colcol',col)

    borderInfo.push({
      rangeType: 'cell',
      value: {
        row_index: startRow,
        col_index: col,
        t: borderStyle,
        ...(col === startCol || (counter % 6 == 0) ? { l: borderStyle } : {}), // Add left border for the top-left cell
        ...(col === endCol ? { r: borderStyle } : {}), // Add right border for the top-right cell
      },
    })

    borderInfo.push({
      rangeType: 'cell',
      value: {
        row_index: endRow,
        col_index: col,
        b: borderStyle,
        ...(col === startCol || (counter % 6 == 0) ? { l: borderStyle } : {}), // Add left border for the bottom-left cell
        ...(col === endCol ? { l: borderStyle } : {}), // Add right border for the bottom-right cell
      },
    })
    counter++
  }

  // // Left and right borders
  // for (var row = startRow + 1; row < endRow; row++) {
  //   borderInfo.push({
  //     "rangeType": "cell",
  //     "value": {
  //       "row_index": row,
  //       "col_index": startCol,
  //       "l": borderStyle
  //     }
  //   });

  //   borderInfo.push({
  //     "rangeType": "cell",
  //     "value": {
  //       "row_index": row,
  //       "col_index": endCol,
  //       "r": borderStyle
  //     }
  //   });
  // }

  return borderInfo
}

function generateWeelyFootBorder(startRow, endRow, startCol, endCol, style, color, top = false, bottom = false) {
  const borderStyle = {
    style,
    color,
  }

  const borderInfo = []
  const counter = 0

  // Top and bottom borders
  if (top) {
    for (var col = startCol; col < endCol; col++) {
      // console.log('colcol',col)

      borderInfo.push({
        rangeType: 'cell',
        value: {
          row_index: startRow,
          col_index: col,
          b: borderStyle,

          // || (counter % 6 == 0) ?
          l: borderStyle, // Add left border for the top-left cell
          r: borderStyle, // Add right border for the top-right cell
        },
      })
    }
  }

  if (bottom) {
    for (var col = startCol; col < endCol; col++) {
      // console.log('colcol',col)

      borderInfo.push({
        rangeType: 'cell',
        value: {
          row_index: startRow,
          col_index: col,
          t: borderStyle,

          // || (counter % 6 == 0) ?
          l: borderStyle, // Add left border for the top-left cell
          r: borderStyle, // Add right border for the top-right cell
        },
      })
    }
  }

  return borderInfo
}

function getFirstDayOfMonth(dateString) {
  const date = moment(dateString)
  const firstDayOfMonth = date.startOf('month')
  const firstDayOfMonthString = firstDayOfMonth.format('YYYY-MM-DD')
  startingWeek.value = firstDayOfMonth.isoWeek()
  console.log('startingWeek.value', startingWeek.value)

  return firstDayOfMonthString
}

function convertJsonForWeek(inputJson) {
  const groupedData = {}

  inputJson.forEach(item => {
    const key = item.userRecordID
    if (groupedData[key]) {
      const weekKey = `${item.weekNumber}-${item.orderType}`
      if (groupedData[key].weekly[weekKey]) {
        groupedData[key].weekly[weekKey].Total += item.totalAmount
        groupedData[key].weekly[weekKey].Unit += 1
      } else {
        groupedData[key].weekly[weekKey] = {
          weekNumber: item.weekNumber.toString(),
          orderType: item.orderType,
          Total: item.totalAmount,
          orderType: item.orderType,
          Unit: 1,
        }
      }
    } else {
      groupedData[key] = {
        center: item.code,
        userRecordID: item.userRecordID,
        fullName: item.fullName,
        position: item.position,
        salesTarget: item.salesTarget,
        weekly: {
          [`${item.weekNumber}-${item.orderType}`]: {
            weekNumber: item.weekNumber.toString(),
            orderType: item.orderType,
            cr_date: item.cr_date,
            Total: item.totalAmount,
            Unit: 1,
          },
        },
      }
    }
  })

  Object.values(groupedData).forEach(item => {
    item.weekly = Object.values(item.weekly)
  })

  return Object.values(groupedData)
}

function dailyDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, arrayLength = 5, OrderTypeOffset = 0, nextRowOffset = 0, bg = '#A6A6A6') {
  const TotalValue = TheArrayValue.Total === undefined ? 0 : TheArrayValue.Total.toString()
  const UnitValue = TheArrayValue.Unit === undefined ? 0 : TheArrayValue.Unit.toString()

  if (nextRowOffset == 0) {
    const cell = {
      r: TotalRow,
      c: (columnOffset + arrayLength * weekDiff + OrderTypeOffset),
      v: {
        m: TotalValue,
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: TotalValue,

        // bg : item.bg ? item.bg : '#FFFFFF'
        ht: 0,
      },

    }

    return cell
  }
  const cell = {
    r: TotalRow + 1,
    c: (columnOffset + arrayLength * weekDiff + OrderTypeOffset),
    v: {
      m: UnitValue,
      ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
      v: UnitValue,
      bg,
      ht: 0,
    },

  }

  return cell
}









function weekDataCellForTotal(Startrow, Startcol, fixOriginalheaders, nextline = 0, index = '1') {
  let cell = {}

  let theFunction = '=SUM('
  theFunction += createExcelColumnMap(fixOriginalheaders.length + Startcol - 5)
  theFunction += `${(Startrow + nextline + 1).toString()}:`
  theFunction += createExcelColumnMap(fixOriginalheaders.length + Startcol - 1)
  theFunction += (Startrow + nextline + 1).toString()
  theFunction += ')'

  if (nextline == 0) {
    cell = {
      r: Startrow,
      c: fixOriginalheaders.length + Startcol,
      v: {
        f: theFunction,
        m: '',
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: '',

        ht: 0,
      },
    }

    const a = [
      {
        r: Startrow,
        c: fixOriginalheaders.length + Startcol,
        index, // sheet id
        func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
        color: 'w', // "w"：use Depth-First-Search "b":Normal search
        parent: null,
        chidren: {},
        times: 0,
      },
    ]
    console.log('aaaaaa', a)

    calcChain_2.value = [...calcChain_2.value, ...a]
  } else {
    cell = {

      r: Startrow + nextline,
      c: fixOriginalheaders.length + Startcol,
      v: {
        m: '',
        f: theFunction,
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: '',
        bg: '#A6A6A6',
        ht: 0,
      },
    }

    const a = [
      {
        r: Startrow + nextline, // the number of rows
        c: fixOriginalheaders.length + Startcol, // the number of columns
        index, // sheet id
        func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
        color: 'w', // "w"：use Depth-First-Search "b":Normal search
        parent: null,
        chidren: {},
        times: 0,
      },
    ]

    calcChain_2.value = [...calcChain_2.value, ...a]
  }
  console.log('totalcell', cell)

  return cell
}

function weekDataCellAdjust(TheArrayValue, columnOffset, weekDiff, TotalRow, OrderTypeOffset = 0, nextRowOffset = 0) {
  const TotalValue = TheArrayValue.Total === undefined ? 0 : TheArrayValue.Total.toString()
  const UnitValue = TheArrayValue.Unit === undefined ? 0 : TheArrayValue.Unit.toString()

  if (nextRowOffset == 0) {
    const cell = {
      r: TotalRow,
      c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
      v: {
        m: TotalValue,
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: TotalValue,

        // bg : item.bg ? item.bg : '#FFFFFF'
        ht: 0,
      },

    }

    return cell
  }
  const cell = {
    r: TotalRow + 1,
    c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
    v: {
      m: UnitValue,
      ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
      v: UnitValue,
      bg: TheArrayValue.bg ? TheArrayValue.bg : '#A6A6A6',
      ht: 0,
    },

  }

  return cell
}

 
function dailyGrandFooter(TempRowArray, columnOffset, weekDiff, CurrentRow,  OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0') {
  let cell = {}

  console.log('OrderTypeOffset', OrderTypeOffset)
  if (nextRowOffset == 0) {
    if (OrderTypeOffset < 8) {
      cell = {
        r: CurrentRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == 7 ? 'Grand Total' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          v: OrderTypeOffset == 7 ? 'Grand Total' : '',

          // bg: OrderTypeOffset == 3 ? bg : '#FFFFFF',
          ...(OrderTypeOffset == 7 ? { bg } : {}),
          ...(OrderTypeOffset == 7 ? { fc: '#FFFFFF' } : {}),

          // fc: '#FFFFFF',
          ht: OrderTypeOffset == 7 ? 1 : 0,
        },

      }

      return cell
    }

 
    let theFunction = '='

    for (let i = 0; i < TempRowArray.length; i++) {
      theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempRowArray[i] - 1)
      if ((i != TempRowArray.length - 1)) {
        theFunction += ' + '
      }
    }
  console.log('createExcelColumnMap',theFunction)

    if (OrderTypeOffset >= 4) {
      cell = {
        r: CurrentRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          f: theFunction,

          //  f: "=K10 + K12",
          m: 0,
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: 0,
          bg,
          ht: 0,

        },

      }

      // createExcelColumnMap

      const a = [
        {
          r: CurrentRow, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index: '0', // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_1.value = [...calcChain_1.value, ...a]

      return cell
    }
  } else {
  
    if (OrderTypeOffset < 8) {
      cell = {
        r: CurrentRow + nextRowOffset ,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == 7 ? 'Unit' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          v: OrderTypeOffset == 7 ? 'Unit' : '',

          // bg: OrderTypeOffset == 3 ? bg : '#FFFFFF',
          ...(OrderTypeOffset == 7 ? { bg } : {}),
          ...(OrderTypeOffset == 7 ? { fc: '#FFFFFF' } : {}),

          // fc: '#FFFFFF',
          ht: OrderTypeOffset == 7 ? 1 : 0,
        },

      }

      return cell
    }
   
      let theFunction = '='

      for (let i = 0; i < TempRowArray.length; i++) {
        theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempRowArray[i])
        if ((i != TempRowArray.length - 1)) {
          theFunction += ' + '
        }
      }

      cell = {
        r: CurrentRow + nextRowOffset ,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          f: theFunction,
          m: '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: '',
          bg,
          ht: 0,
        },

      }

      const a = [
        {
          r: CurrentRow + nextRowOffset , // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index: '0', // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_1.value = [...calcChain_1.value, ...a]

      return cell
    }
   

  // return cell;
}


function weeklyGrandFooter(TempRowArray, columnOffset, weekDiff, TotalRow, TempTotalRow, OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0') {
  let cell = {}

  console.log('OrderTypeOffset', OrderTypeOffset)
  if (nextRowOffset == 0) {
    if (OrderTypeOffset < 4) {
      cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == 3 ? 'Grand Total' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          v: OrderTypeOffset == 3 ? 'Grand Total' : '',

          // bg: OrderTypeOffset == 3 ? bg : '#FFFFFF',
          ...(OrderTypeOffset == 3 ? { bg } : {}),
          ...(OrderTypeOffset == 3 ? { fc: '#FFFFFF' } : {}),

          // fc: '#FFFFFF',
          ht: OrderTypeOffset == 3 ? 1 : 0,
        },

      }

      return cell
    }

    const counter = (TotalRow - TempTotalRow) / 2

    // console.log('counter', counter)
    let theFunction = '='

    for (let i = 0; i < TempRowArray.length; i++) {
      theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempRowArray[i] - 1)
      if ((i != TempRowArray.length - 1)) {
        theFunction += ' + '
      }
    }

    if (OrderTypeOffset >= 4) {
      cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          f: theFunction,

          //  f: "=K10 + K12",
          m: 0,
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: 0,
          bg,
          ht: 0,

        },

      }

      // createExcelColumnMap

      const a = [
        {
          r: TotalRow, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index: '1', // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_2.value = [...calcChain_2.value, ...a]

      return cell
    }
  } else {
    if (OrderTypeOffset < 4) {
      cell = {
        r: TotalRow + 1,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == 3 ? 'Grand Unit' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: OrderTypeOffset == 3 ? 'Grand Unit' : '',

          // bg: OrderTypeOffset == 3 ? bg : '#FFFFFF',
          ...(OrderTypeOffset == 3 ? { bg } : {}),
          ...(OrderTypeOffset == 3 ? { fc: '#FFFFFF' } : {}),
          ht: OrderTypeOffset == 3 ? 1 : 0,

        },

      }

      return cell
    }

    if (OrderTypeOffset >= 4) {
      const counter = (TotalRow - TempTotalRow) / 2

      //  console.log('counter' ,counter)
      let theFunction = '='

      for (let i = 0; i < TempRowArray.length; i++) {
        theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempRowArray[i])
        if ((i != TempRowArray.length - 1)) {
          theFunction += ' + '
        }
      }

      cell = {
        r: TotalRow + 1,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          f: theFunction,
          m: '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: '',
          bg,
          ht: 0,
        },

      }

      const a = [
        {
          r: TotalRow + 1, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index: '1', // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_2.value = [...calcChain_2.value, ...a]

      return cell
    }
  }

  // return cell;
}
 




function dailyFooterSum(currentRow, TargetColumn, { OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0', index = '0' }) {
  const colIndex_1 = createExcelColumnMap(TargetColumn - 2)
  const colIndex_2 = createExcelColumnMap(TargetColumn + 1)
  const theFunction = `=SUM(${colIndex_1}${currentRow - 1}:${colIndex_2}${currentRow - 1})`

  const cell = {
    r: currentRow,
    c: TargetColumn,
    v: {
      f: theFunction,
      m: 0,
      ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },

      // fc: '#FFFFFF',
      v: 0,
      ht: 2,

      //  bg : bg
    },
  }

  const a = [
    {
      r: currentRow, // the number of rows
      c: TargetColumn, // the number of columns
      index, // sheet id
      func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
      color: 'w', // "w"：use Depth-First-Search "b":Normal search
      parent: null,
      chidren: {},
      times: 0,
    },
  ]
  calcChain_1.value = [...calcChain_1.value, ...a]

  return cell
}

function dailyFooter(originalHeaders, TheArrayValue, columnOffset, weekDiff, TotalRow, TempTotalRow, { OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0', index = '0' }) {
  const TotalValue = TheArrayValue.Total === undefined ? 0 : TheArrayValue.Total.toString()
  const UnitValue = TheArrayValue.Unit === undefined ? 0 : TheArrayValue.Unit.toString()

  // // const originalHeaders = ['Center', 'Coach Name', 'Position', 'Target', '100%', 'Diff', '%', '',
  // //  'New', 'Renew', 'FS', 'BR', 'MTD', 'Pit士多'];

  const index1 = originalHeaders.findIndex(theCell => theCell === 'Position')
  const index2 = originalHeaders.findIndex(theCell => theCell === 'Target')
  const index3 = originalHeaders.findIndex(theCell => theCell === '')
  const index4 = originalHeaders.findIndex(theCell => theCell === '%')

  // console.log('index2',index2)
  const internalSumCount = 0

  // if this row(Total)
  if (nextRowOffset == 0) {
    if (OrderTypeOffset <= index1 || OrderTypeOffset == index4 || OrderTypeOffset == index3) {
      const cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
        //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == index3 ? 'Total' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: OrderTypeOffset == index3 ? 'Total' : '',
          bg,

        },

      }

      return cell
    }

    const counter = (TotalRow - TempTotalRow) / 2

    // console.log('counter', counter)
    let theFunction = '='

    for (let i = 0; i < counter; i++) {
      theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempTotalRow + 2 * i + 1)
      if (!(counter == i + 1)) {
        theFunction += ' + '
      }
    }
    if (OrderTypeOffset >= index2 && OrderTypeOffset <= index3) {
      const cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {

          f: theFunction,
          m: 0,
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: 0,
          bg,
          ht: 0,
        },
      }
      const a = [
        {
          r: TotalRow, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index, // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_1.value = [...calcChain_1.value, ...a]

      return cell
    }

    if (OrderTypeOffset > index3) {
      const cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          ...OrderTypeOffset == index3 ? {} : { f: theFunction },
          m: OrderTypeOffset == index3 ? 'Total' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: OrderTypeOffset == index3 ? 'Total' : '',
          bg,
          ht: OrderTypeOffset == index3 ? 1 : 0,
        },
      }

      const a = [
        {
          r: TotalRow, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index, // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_1.value = [...calcChain_1.value, ...a]

      return cell
    }
  } else {
    if (OrderTypeOffset < index3) {
      const cell = {
        r: TotalRow + nextRowOffset,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
        //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: '',

          // bg:   '#FFFFFF',
          v: '',
        },
      }

      return cell
    }

    if (OrderTypeOffset == index3) {
      const cell = {
        r: TotalRow + nextRowOffset,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
        //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == index3 ? 'Unit' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: OrderTypeOffset == index3 ? 'Unit' : '',
          bg: OrderTypeOffset == index3 ? bg : '#FFFFFF',
          v: OrderTypeOffset == index3 ? 'Unit' : '',
        },
      }

      return cell
    }

    const counter = (TotalRow - TempTotalRow) / 2

    // console.log('counter', counter)
    let theFunction = '='

    for (let i = 0; i < counter; i++) {
      theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (nextRowOffset + TempTotalRow + 2 * i + 1)
      if (!(counter == i + 1)) {
        theFunction += ' + '
      }
    }
    if (OrderTypeOffset > index3) {
      const cell = {
        r: TotalRow + nextRowOffset,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {

          f: theFunction,
          m: 0,
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: 0,
          bg,
          ht: 0,
        },
      }
      const a = [
        {
          r: TotalRow + nextRowOffset, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index, // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_1.value = [...calcChain_1.value, ...a]

      return cell
    }
  }
}





function weeklyFooter(TheArrayValue, columnOffset, weekDiff, TotalRow, TempTotalRow, OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0', index = '1') {
  const TotalValue = TheArrayValue.Total === undefined ? 0 : TheArrayValue.Total.toString()
  const UnitValue = TheArrayValue.Unit === undefined ? 0 : TheArrayValue.Unit.toString()

  // console.log('OrderTypeOffset', OrderTypeOffset)
  if (nextRowOffset == 0) {
    if (OrderTypeOffset < 4) {
      const cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == 3 ? 'Total' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: OrderTypeOffset == 3 ? 'Total' : '',
          bg,
          ht: OrderTypeOffset == 3 ? 1 : 0,

        },

      }

      return cell
    }

    const counter = (TotalRow - TempTotalRow) / 2

    // console.log('counter', counter)
    let theFunction = '='

    for (let i = 0; i < counter; i++) {
      theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempTotalRow + 2 * i + 1)
      if (!(counter == i + 1)) {
        theFunction += ' + '
      }
    }

    //  console.log('theFunction',theFunction)

    if (OrderTypeOffset >= 4) {
      const cell = {
        r: TotalRow,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          f: theFunction,

          //  f: "=K10 + K12",
          m: 0,
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          v: 0,
          fc: '#FFFFFF',
          bg,
          ht: 0,

        },

      }

      // createExcelColumnMap

      const a = [
        {
          r: TotalRow, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index, // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_2.value = [...calcChain_2.value, ...a]

      return cell
    }
  } else {
    if (OrderTypeOffset < 4) {
      const cell = {
        r: TotalRow + 1,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          //  "f": "=MAX({{createExcelColumnMap}}7:A9)",
          m: OrderTypeOffset == 3 ? 'Unit' : '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          fc: '#FFFFFF',
          v: OrderTypeOffset == 3 ? 'Unit' : '',
          ...(OrderTypeOffset <= 3 ? { bg } : {}),
          ht: OrderTypeOffset == 3 ? 1 : 0,

        },

      }

      return cell
    }

    if (OrderTypeOffset >= 4) {
      const counter = (TotalRow - TempTotalRow) / 2

      //  console.log('counter' ,counter)
      let theFunction = '='

      for (let i = 0; i < counter; i++) {
        theFunction += createExcelColumnMap(columnOffset + 6 * weekDiff + OrderTypeOffset) + (TempTotalRow + 2 * i + 2)
        if (!(counter == i + 1)) {
          theFunction += ' + '
        }
      }

      const cell = {
        r: TotalRow + 1,
        c: (columnOffset + 6 * weekDiff + OrderTypeOffset),
        v: {
          f: theFunction,
          m: '',
          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
          v: '',
          fc: '#FFFFFF',
          bg,
          ht: 0,
        },

      }

      const a = [
        {
          r: TotalRow + 1, // the number of rows
          c: (columnOffset + 6 * weekDiff + OrderTypeOffset), // the number of columns
          index, // sheet id
          func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
          color: 'w', // "w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0,
        },
      ]
      calcChain_2.value = [...calcChain_2.value, ...a]

      return cell
    }
  }
}

function createExcelColumnMap(n) {
  let columnLabel = ''
  let temp = n + 1
  while (temp > 0) {
    const remainder = (temp - 1) % 26
    columnLabel = String.fromCharCode(65 + remainder) + columnLabel
    temp = Math.floor((temp - remainder) / 26)
  }

  return columnLabel
}

// function createExcelColumnMap(n) {
//     const map = {};
//     for (let i = 0; i < n; i++) {
//         let columnLabel = '';
//         let temp = i + 1;
//         while (temp > 0) {
//             let remainder = (temp - 1) % 26;
//             columnLabel = String.fromCharCode(65 + remainder) + columnLabel;
//             temp = Math.floor((temp - remainder) / 26);
//         }
//         map[i] = columnLabel;
//     }
//     return map;
// }

</script>
